import { initialState } from "@/models/options";

const v23 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        editorialDistributionTable: {
          ...initialState.tableViews.editorialDistributionTable,
        },
      },
    },
  };
};

export default v23;
